import cloneDeep from 'clone-deep'
import { useSelector } from 'react-redux'
import { MultiSelect } from 'stories/components'

const lockRateRestrictionConditions = {
  requiredInterestRate: 'Interest Rate is Required',
  requiredLoanSign: 'Loan Application Sign is Required',
  requiredLoanAppData: 'Loan Application Data should be completed',
}

export const lockRateMoreRules = {
  restructureReleaseOff: 'Restructure Release Off',
  restructureReleaseOn: 'Restructure Release On',
}

const lockTypes: Record<string, string> = {
  initialLock: 'Initial Lock',
  relock: 'Relock',
  lockExtension: 'Lock Extension',
}

export const LockRateRestriction = ({
  value,
  onChange: _onChange,
  onBlur,
}: {
  value: Record<string, any>
  onChange: Function
  onBlur?: Function
}) => {
  const [loanGlobalStatus] = useSelector((state: any) => [state.loanGlobalStatus])

  const onChange = (key: string, type: string, v: string) => {
    const newValue = cloneDeep(value)
    if (!newValue[key]) newValue[key] = {}
    newValue[key][type] = v
    _onChange(newValue)
  }

  return (
    <div className="">
      {Object.keys(lockTypes).map((key, index) => {
        return (
          <div className="grid grid-cols-4 gap-4 mb-4 items-center" key={key}>
            <p className="pl-4">
              {index + 1}. {lockTypes[key]}
            </p>
            <MultiSelect
              id={`${key}-loanStatus`}
              title="Loan Status"
              options={loanGlobalStatus}
              value={value?.[key]?.['loanStatus']}
              onChange={(value) => onChange(key, 'loanStatus', value)}
              onBlur={() => onBlur && onBlur()}
            />
            <MultiSelect
              id={`${key}-conditions`}
              title="Conditions"
              options={lockRateRestrictionConditions}
              value={value?.[key]?.['conditions']}
              onChange={(value) => onChange(key, 'conditions', value)}
              onBlur={() => onBlur && onBlur()}
            />
            <MultiSelect
              id={`${key}-moreRules`}
              title="More Rules"
              options={lockRateMoreRules}
              value={value?.[key]?.['moreRules'] || {}}
              defaultSelected={false}
              onChange={(value) => onChange(key, 'moreRules', value)}
              onBlur={() => onBlur && onBlur()}
            />
          </div>
        )
      })}
    </div>
  )
}
